import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4f244044 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _c0d6e1b2 = () => interopDefault(import('../pages/bindAccount.vue' /* webpackChunkName: "pages/bindAccount" */))
const _cfe1bade = () => interopDefault(import('../pages/consent.vue' /* webpackChunkName: "pages/consent" */))
const _6edc1b09 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0d8017f1 = () => interopDefault(import('../pages/me.vue' /* webpackChunkName: "pages/me" */))
const _0e1b1a7c = () => interopDefault(import('../pages/mp.vue' /* webpackChunkName: "pages/mp" */))
const _373fea48 = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _3e62639f = () => interopDefault(import('../pages/pay.vue' /* webpackChunkName: "pages/pay" */))
const _2421b5ec = () => interopDefault(import('../pages/procedure.vue' /* webpackChunkName: "pages/procedure" */))
const _0fd965c7 = () => interopDefault(import('../pages/setting.vue' /* webpackChunkName: "pages/setting" */))
const _6bce3769 = () => interopDefault(import('../pages/takings/index.vue' /* webpackChunkName: "pages/takings/index" */))
const _1f9c4cba = () => interopDefault(import('../pages/wx.vue' /* webpackChunkName: "pages/wx" */))
const _85510992 = () => interopDefault(import('../pages/auth/binding.vue' /* webpackChunkName: "pages/auth/binding" */))
const _3eb56c61 = () => interopDefault(import('../pages/auth/forgot.vue' /* webpackChunkName: "pages/auth/forgot" */))
const _8b662a02 = () => interopDefault(import('../pages/auth/help.vue' /* webpackChunkName: "pages/auth/help" */))
const _43bbeeca = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _206f5659 = () => interopDefault(import('../pages/auth/password.vue' /* webpackChunkName: "pages/auth/password" */))
const _ce4ef33e = () => interopDefault(import('../pages/auth/register.vue' /* webpackChunkName: "pages/auth/register" */))
const _0f03da68 = () => interopDefault(import('../pages/oauth/authorize.vue' /* webpackChunkName: "pages/oauth/authorize" */))
const _85729f80 = () => interopDefault(import('../pages/order/checkout.vue' /* webpackChunkName: "pages/order/checkout" */))
const _6a5681b6 = () => interopDefault(import('../pages/order/confirm.vue' /* webpackChunkName: "pages/order/confirm" */))
const _799277db = () => interopDefault(import('../pages/teams/policies/privacy.vue' /* webpackChunkName: "pages/teams/policies/privacy" */))
const _145d6616 = () => interopDefault(import('../pages/teams/policies/refund.vue' /* webpackChunkName: "pages/teams/policies/refund" */))
const _a5f486f0 = () => interopDefault(import('../pages/teams/policies/service.vue' /* webpackChunkName: "pages/teams/policies/service" */))
const _71939e6c = () => interopDefault(import('../pages/order/product/_product.vue' /* webpackChunkName: "pages/order/product/_product" */))
const _46e5e470 = () => interopDefault(import('../pages/orders/_order.vue' /* webpackChunkName: "pages/orders/_order" */))
const _499f2caf = () => interopDefault(import('../pages/s/_token.vue' /* webpackChunkName: "pages/s/_token" */))
const _1db5ffde = () => interopDefault(import('../pages/takings/_id.vue' /* webpackChunkName: "pages/takings/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _4f244044,
    name: "about___mo"
  }, {
    path: "/bindAccount",
    component: _c0d6e1b2,
    name: "bindAccount___mo"
  }, {
    path: "/consent",
    component: _cfe1bade,
    name: "consent___mo"
  }, {
    path: "/hk",
    component: _6edc1b09,
    name: "index___hk"
  }, {
    path: "/me",
    component: _0d8017f1,
    name: "me___mo"
  }, {
    path: "/mp",
    component: _0e1b1a7c,
    name: "mp___mo"
  }, {
    path: "/order",
    component: _373fea48,
    name: "order___mo"
  }, {
    path: "/pay",
    component: _3e62639f,
    name: "pay___mo"
  }, {
    path: "/procedure",
    component: _2421b5ec,
    name: "procedure___mo"
  }, {
    path: "/setting",
    component: _0fd965c7,
    name: "setting___mo"
  }, {
    path: "/takings",
    component: _6bce3769,
    name: "takings___mo"
  }, {
    path: "/wx",
    component: _1f9c4cba,
    name: "wx___mo"
  }, {
    path: "/auth/binding",
    component: _85510992,
    name: "auth-binding___mo"
  }, {
    path: "/auth/forgot",
    component: _3eb56c61,
    name: "auth-forgot___mo"
  }, {
    path: "/auth/help",
    component: _8b662a02,
    name: "auth-help___mo"
  }, {
    path: "/auth/login",
    component: _43bbeeca,
    name: "auth-login___mo"
  }, {
    path: "/auth/password",
    component: _206f5659,
    name: "auth-password___mo"
  }, {
    path: "/auth/register",
    component: _ce4ef33e,
    name: "auth-register___mo"
  }, {
    path: "/hk/about",
    component: _4f244044,
    name: "about___hk"
  }, {
    path: "/hk/bindAccount",
    component: _c0d6e1b2,
    name: "bindAccount___hk"
  }, {
    path: "/hk/consent",
    component: _cfe1bade,
    name: "consent___hk"
  }, {
    path: "/hk/me",
    component: _0d8017f1,
    name: "me___hk"
  }, {
    path: "/hk/mp",
    component: _0e1b1a7c,
    name: "mp___hk"
  }, {
    path: "/hk/order",
    component: _373fea48,
    name: "order___hk"
  }, {
    path: "/hk/pay",
    component: _3e62639f,
    name: "pay___hk"
  }, {
    path: "/hk/procedure",
    component: _2421b5ec,
    name: "procedure___hk"
  }, {
    path: "/hk/setting",
    component: _0fd965c7,
    name: "setting___hk"
  }, {
    path: "/hk/takings",
    component: _6bce3769,
    name: "takings___hk"
  }, {
    path: "/hk/wx",
    component: _1f9c4cba,
    name: "wx___hk"
  }, {
    path: "/oauth/authorize",
    component: _0f03da68,
    name: "oauth-authorize___mo"
  }, {
    path: "/order/checkout",
    component: _85729f80,
    name: "order-checkout___mo"
  }, {
    path: "/order/confirm",
    component: _6a5681b6,
    name: "order-confirm___mo"
  }, {
    path: "/hk/auth/binding",
    component: _85510992,
    name: "auth-binding___hk"
  }, {
    path: "/hk/auth/forgot",
    component: _3eb56c61,
    name: "auth-forgot___hk"
  }, {
    path: "/hk/auth/help",
    component: _8b662a02,
    name: "auth-help___hk"
  }, {
    path: "/hk/auth/login",
    component: _43bbeeca,
    name: "auth-login___hk"
  }, {
    path: "/hk/auth/password",
    component: _206f5659,
    name: "auth-password___hk"
  }, {
    path: "/hk/auth/register",
    component: _ce4ef33e,
    name: "auth-register___hk"
  }, {
    path: "/hk/oauth/authorize",
    component: _0f03da68,
    name: "oauth-authorize___hk"
  }, {
    path: "/hk/order/checkout",
    component: _85729f80,
    name: "order-checkout___hk"
  }, {
    path: "/hk/order/confirm",
    component: _6a5681b6,
    name: "order-confirm___hk"
  }, {
    path: "/teams/policies/privacy",
    component: _799277db,
    name: "teams-policies-privacy___mo"
  }, {
    path: "/teams/policies/refund",
    component: _145d6616,
    name: "teams-policies-refund___mo"
  }, {
    path: "/teams/policies/service",
    component: _a5f486f0,
    name: "teams-policies-service___mo"
  }, {
    path: "/hk/teams/policies/privacy",
    component: _799277db,
    name: "teams-policies-privacy___hk"
  }, {
    path: "/hk/teams/policies/refund",
    component: _145d6616,
    name: "teams-policies-refund___hk"
  }, {
    path: "/hk/teams/policies/service",
    component: _a5f486f0,
    name: "teams-policies-service___hk"
  }, {
    path: "/",
    component: _6edc1b09,
    name: "index___mo"
  }, {
    path: "/hk/order/product/:product?",
    component: _71939e6c,
    name: "order-product-product___hk"
  }, {
    path: "/hk/orders/:order?",
    component: _46e5e470,
    name: "orders-order___hk"
  }, {
    path: "/hk/s/:token?",
    component: _499f2caf,
    name: "s-token___hk"
  }, {
    path: "/hk/takings/:id",
    component: _1db5ffde,
    name: "takings-id___hk"
  }, {
    path: "/order/product/:product?",
    component: _71939e6c,
    name: "order-product-product___mo"
  }, {
    path: "/orders/:order?",
    component: _46e5e470,
    name: "orders-order___mo"
  }, {
    path: "/s/:token?",
    component: _499f2caf,
    name: "s-token___mo"
  }, {
    path: "/takings/:id",
    component: _1db5ffde,
    name: "takings-id___mo"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
